__turbopack_context__.v({
  "ctaContainer": "styles-module__e_UN7a__ctaContainer",
  "gridContainer": "styles-module__e_UN7a__gridContainer",
  "title": "styles-module__e_UN7a__title",
  "wrapper": "styles-module__e_UN7a__wrapper",
});
